export default "__VITE_ASSET__03dce72b__"